module.exports = __webpack_public_path__ + "static/media/liveroom-promote-income-icon.9b769a04.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wallet/liveroom-promote-income-icon.png
// module id = 2071
// module chunks = 6